import {Component, Input} from '@angular/core';
import {
  AnimalMarkerSvgComponent
} from "src/app/presentation/common/icons/animal-marker-svg/animal-marker-svg.component";
import {AnimalType} from "src/app/infrastructure/moovement-api/models/asset";

@Component({
  selector: 'app-animal-marker',
  imports: [
    AnimalMarkerSvgComponent
  ],
  templateUrl: './animal-marker.component.html',
  styleUrl: './animal-marker.component.css'
})
export class AnimalMarkerComponent {

  @Input() animalType?: AnimalType = AnimalType.UNKNOWN
  @Input() name?: string = undefined
  @Input() hasWarning: boolean = false
  @Input() width: string = '20'
  @Input() height: string = '20'

}
